import { __decorate } from "tslib";
import { EventEmitter } from 'events';
import * as CONST from './const';
import CalculatorProject from './project';
import Calculator from './calculator';
import CalculatorProjectPrice from './price';
import Reportable from './decorators/reportable';
import CalculatorModulesUI from './ui.modules';
import CalculatorUI from './ui/';
function convertBagetURL(url) {
    return `https://muse.ooo/upload/bagets/${url}`;
}
class nmModuleCalc extends EventEmitter {
    options;
    uniqueId = (Math.random() * 1000).toString();
    project;
    calculator;
    price;
    ui;
    modulesUI;
    constructor(options) {
        super();
        this.options = options;
        this.calculator = new Calculator({
            name: options.name,
            server: options.server,
            host: options.host,
            preserveFormat: options.preserveFormat,
            paspartuOverflow: options.paspartuOverflow,
        });
        this.project = new CalculatorProject({
            image: CONST.DEFAULT_IMAGE,
            properties: new Map()
        }, this.calculator);
        this.price = new CalculatorProjectPrice(this.calculator, this.project);
        this.ui = new CalculatorUI(options, this.calculator, this.project, {});
        this.modulesUI = new CalculatorModulesUI(options.targetId, this.calculator, this.project);
        this.bindPriceEventsToUI();
        this.init().catch(e => console.error(e));
    }
    async init() {
        await this.calculator.load();
        this.project.on('material', () => {
            this.project.setProject(this.calculator.getDefaultProject());
            this.price.updateAllPrices();
            this.ui.updateUIFromSummary();
        });
        this.project.setProject(this.calculator.getDefaultProject());
        this.modulesUI.onSizeChange(CONST.DEFAULT_PICTURE_DIMENSION_RATE);
        this.ui.render();
        this.price.updateAllPrices();
        this.project.on('total.changed', (val) => {
            this.emit('price.changed.total', val);
        });
        this.project.on('price.changed.baget', (val) => {
            this.emit('price.changed.baget', val?.price);
        });
        this.project.on('summary.changed', (val) => {
            this.emit('summary.changed', val);
        });
        this.project.on('propertyRemoved', (val) => {
            this.emit('property.removed', val);
        });
        this.project.on('propertyChanged', (val) => {
            this.emit('property.changed', val);
        });
    }
    bindPriceEventsToUI() {
        this.price.on('changed', (val) => {
            console.log('price.changed', val);
            this.ui.updatePropertyPriceTag(val);
        });
        this.price.on('bagets.changed', (prices) => {
            console.log('price event: bagets.changed', prices);
            this.ui.updateBagetsPrices(prices);
        });
    }
    setReference(pic) {
        this.project.changeImage(pic);
        this.ui.scrollIntoView();
    }
    getTotal() {
        return this.project.getTotal();
    }
    getBagetPrice() {
        return this.project.getBagetPrice();
    }
    getName() {
        return this.calculator.getName();
    }
}
__decorate([
    Reportable
], nmModuleCalc.prototype, "init", null);
export default nmModuleCalc;
